<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <h4 class="card-title">系统日志</h4>
          </template>	  

		  
          <div class="table-responsive text-left">			  
				  <el-table class="table" 
				  :data="logs" width="100%"  
				  highlight-current-row
				  tooltip-effect="dark"
				  >
				  <el-table-column prop="logMethod" label="动作"></el-table-column>
				  <el-table-column prop="logDesc" label="详情"></el-table-column>
				  <el-table-column prop="logIp" label="IP"></el-table-column>
				  <el-table-column prop="telParams" label="参数"></el-table-column>
				  <el-table-column prop="logUrl" label="地址"></el-table-column>
				  <el-table-column prop="createTime" label="时间"></el-table-column>
				  <el-table-column prop="createId" label="用户ID"></el-table-column>
			      </el-table>
          </div>
		  <div class="block">
		    <el-pagination
		      @size-change="handleSizeChange"
		      @current-change="pageHandleCurrentChange"
		      :current-page="pageParam.currentPage"
		      :page-sizes="[10, 20, 50, 100]"
		      :page-size="10"
		      :layout="layout"
		      :total="pageParam.total">
		    </el-pagination>
		  </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Card } from "@/components/index";
import { Message,MessageBox} from "element-ui";
export default {
  components: {
    Card,
  },
  data() {
    return {
		logs:[],
		pageParam:{
			pageNum:1,
			pageSize:10,
			total:0,
			currentPage:1,
			pages:1,
		},
		layout:"total,sizes,prev,pager,next,jumper",
    };
  },
  created() {
	  this.list();
  },
  methods:{
	async list(){
		this.$axios.post(this.$serverUrl+"/sys/log/list",this.pageParam).then(Response=>{
			console.log(Response);
			if(Response.status==200){
				this.logs=Response.data.data.list;
				this.pageParam.total=Response.data.data.total;
				this.pageParam.pages=Response.data.data.pages;
			}else{
				Message(
				{
				 type: "error",
				 message: Response.data.msg,
				 offset:window.screen.height/2-100
				});
			}
		});		
		
		console.log(this.logs);
	},
	handleSizeChange(val){
		this.pageParam.pageSize=val;
		this.list();
	},
	pageHandleCurrentChange(val){
		this.pageParam.pageNum=val;
		this.list();
	}
  }
};
</script>
<style>
	modal input{
		margin-top:5px;
		text-align:left;
	}
	
	.search input{
		display:inline;
		margin-right:5px;
	}
	.el-message-box__message p{
		color:#000;
	}
</style>
